// removed by extract-text-webpack-plugin
module.exports = {"grid":"styles__grid___gMLiL"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/grid/styles.css
// module id = /Ls7
// module chunks = 2